import React, { createContext, useContext } from 'react';

const SingleListingFormContext = createContext(null);

/**
 * Hook to access Single Listing Generator form state and handlers.
 * Use inside SingleListingFormProvider (e.g. FormSteps and its children).
 */
export const useSingleListingForm = () => {
  const context = useContext(SingleListingFormContext);
  if (!context) {
    throw new Error('useSingleListingForm must be used within SingleListingFormProvider');
  }
  return context;
};

/**
 * Provider for Single Listing form context. Wrap the form area (e.g. form card)
 * and pass the combined value from SingleListingGeneratorPage.
 */
export const SingleListingFormProvider = ({ value, children }) => (
  <SingleListingFormContext.Provider value={value}>
    {children}
  </SingleListingFormContext.Provider>
);
